import axios from "../../../../axios";
import React, { useState } from "react";
import "./editDelete.css";
import assets from "../../../../assets/assets";

const DeleteReply = ({ setReply, replyId, setDelet, setDeleted, setFilter, getReplyReload }) => {
  const Student_Id = JSON.parse(localStorage.getItem("breathForStudent"));
  const user_id = Student_Id?.id;
  const [isInProgress, setIsInProgress] = useState(false);
  const handleDelete = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.delete(`/query/reply/delete/${replyId}`, {
        data: { user_id },
      });
      if (res) {
        setFilter((prevState) => ({ ...prevState, page: 1 }));
        // setDeleted((prev) => !prev);
        getReplyReload()
        setDelet(false)
      }
      setReply([]);
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  return (
    <>
      <div className=" delete_reply_transprant_body ">

        <div className="p-3 d-flex align-items-center delete_reply_container shadow relative">
          <img
            src={assets.CrossIcon}
            className="w-10 p-2"
            style={{ position: "absolute", top: "0", right: "0" }}
            alt=""
            onClick={(e) => setDelet(false)}
          />
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mt-4 mb-5 delete_reply_text">
              Are you sure you want to delete this message?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                disabled={isInProgress}
                className="btn btn-danger col-sm-5  reply_delete_btn"
                onClick={handleDelete}
              >
                Yes
              </button>
              <button
                disabled={isInProgress}
                className="btn btn-danger col-sm-5 reply_delete_btn no"
                onClick={(e) => setDelet(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteReply;
